import { amplitudeTrack } from '@cw-elements/analytics-provider';

const COMPONENT = 'Accounts';

/**
 * Client-side port of the React accounts password-recovery tracking
 * (signin.component.tsx + recovery.component.tsx), so the server-rendered pages
 * emit the same named events as the SPA:
 *  - "user recover password" (Recovery password): clicking the forgot-password
 *    link on the sign-in page.
 *  - "user reset password" (Send email): submitting the email on the recovery page.
 * The SPA does not track the new-password (reset) submit, so neither do we.
 */

export const normalizeEmail = (value) => value?.toLowerCase().trim() || null;

// The recovery page renders <input type="email" name="email">, but the sign-in
// form — where the forgot-password link lives — renders the email as
// <input type="text" name="cropwise_user[email]">. Without the suffixed [email]
// match, "user recover password" finds no email and is skipped entirely.
export const SIGN_IN_EMAIL_SELECTOR =
  'input[type="email"], input[name="email"], input[name$="[email]"]';

const emailFrom = (root) => normalizeEmail(root?.querySelector(SIGN_IN_EMAIL_SELECTOR)?.value);

const trackRecoverPassword = (email) => {
  if (!email) return;
  amplitudeTrack('user recover password', {
    component: COMPONENT,
    email,
    action: 'Recovery password',
  });
};

const trackResetPassword = (email) => {
  if (!email) return;
  amplitudeTrack('user reset password', {
    component: COMPONENT,
    email,
    action: 'Send email',
  });
};

// Fire-and-forget and let the link/form navigate normally: analytics.js inits
// Amplitude with beacon transport and flushes on page hide, so the queued event
// survives the navigation without us holding up (and breaking) it.
export const initPasswordRecoveryEvents = () => {
  // "user recover password": the forgot-password link on the sign-in page,
  // carrying the email currently typed into the sign-in form (mirrors the SPA).
  const forgotLink = document.querySelector('.devise-form-wrapper__forgot-password a');
  forgotLink?.addEventListener('click', () => {
    trackRecoverPassword(emailFrom(forgotLink.closest('form') ?? document));
  });

  // "user reset password": submitting the email on the recovery page.
  const recoveryForm = document.querySelector('.devise-form-recovery-password form');
  recoveryForm?.addEventListener('submit', () => {
    trackResetPassword(emailFrom(recoveryForm));
  });
};
